<template>
  <header
    class="flex h-14 flex-shrink-0 items-center justify-between border-b py-2 pe-2 ps-4 surface-panel-blur brd-highlight"
  >
    <h1
      class="mb-0 flex w-full flex-nowrap items-center gap-2 text-2xl text-gray-900 dark:text-gray-100"
    >
      <back-button
        v-if="showBackButton"
        :button-label="backButtonLabel"
        :back-url="backUrl"
      />
      <fluent-icon v-if="icon" :icon="icon" :class="iconClass" />
      <slot />
      <span
        class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-2xl font-medium text-gray-900 dark:text-gray-100"
      >
        {{ headerTitle }}
      </span>
    </h1>
    <router-link
      v-if="showNewButton && isAdmin"
      :to="buttonRoute"
      class="button success button--fixed-top !static flex gap-2 rounded-[5px] px-3.5 py-1"
    >
      <fluent-icon icon="add-circle" />

      <span class="button__content">
        {{ buttonText }}
      </span>
    </router-link>
  </header>
</template>
<script>
import { mapGetters } from 'vuex';
import BackButton from '../../../components/widgets/BackButton.vue';
import adminMixin from '../../../mixins/isAdmin';

export default {
  components: {
    BackButton,
  },
  mixins: [adminMixin],
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    buttonRoute: {
      default: '',
      type: String,
    },
    buttonText: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    showNewButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
  },
};
</script>
